import React, { useEffect, useState} from "react";
import GlipLogo from '../../styles/assets/glip_logo.svg';

import styled from 'styled-components';


const GlipWalletHeaderDiv = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    background: #26283E;
    height: 50px;
    padding: 8px;
`;

const GlipHeaderTextSpan = styled.span`    
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 125%;
    text-align: left;
    letter-spacing: 0.1px;
    color: #FFFFFF;
`

const WalletHeadComponent = (props:any) => {
    
    return (
        <GlipWalletHeaderDiv>
          <div>
            <img style={{maxHeight:23, marginRight:10,
                             marginLeft:10}} src={GlipLogo} />
          </div>
          <GlipHeaderTextSpan>
            Glip Wallet
          </GlipHeaderTextSpan>
        </GlipWalletHeaderDiv>);
    
}

export default WalletHeadComponent;
